import React from 'react';
import styles from './styles.module.scss';
import { SlideAnswer } from '../../types';

interface ChoiceGridProps {
  answers: SlideAnswer[];
  selectedValue?: string;
  onSelect: (value: string) => void;
  columns?: 1 | 2 | 3;
}

/**
 * Griglia di opzioni per le slide a scelta singola/multipla
 */
const ChoiceGrid: React.FC<ChoiceGridProps> = ({
  answers,
  selectedValue,
  onSelect,
  columns = 2,
}) => {
  const handleClick = (value: string) => {
    onSelect(value);
  };

  return (
    <div
      className={styles.choiceGrid}
      data-columns={columns}
    >
      {answers.map((answer, index) => (
        <button
          key={index}
          type="button"
          className={`${styles.choiceOption} ${
            selectedValue === answer.value ? styles.active : ''
          }`}
          onClick={() => handleClick(answer.value)}
        >
          {answer.image && (
            <img
              src={answer.image}
              alt={answer.label}
              className={styles.optionImage}
              onError={(e) => {
                // Hide broken images
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          )}
          <span className={styles.optionLabel}>{answer.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ChoiceGrid;

